/* eslint-disable react/prop-types */
import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import { useSoftUIController, setMiniSidenav } from "context";

function Header({ topTab, setTopTab }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;

  // top tabs
  const topTabs = ["Configurations"];

  return (
    <SoftBox sx={{ position: "sticky", zIndex: 1000 }}>
      {/* 🔹 TOP HEADER */}
      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={3}
        py={1}
        sx={{
          background:
            "linear-gradient(87deg, rgb(41, 88, 182) 0, rgb(40, 62, 152) 100%)",
          borderRadius: "10px",
        }}
      >
        {/* LEFT TABS */}
        <SoftBox display="flex" gap={3}>
          {topTabs.map((tab) => (
            <SoftTypography
              key={tab}
              variant="h6"
              fontWeight="medium"
              onClick={() => setTopTab(tab)}
              sx={{
                cursor: "pointer",
                color:
                  topTab === tab
                    ? "#fff"
                    : "rgba(255,255,255,0.8)",
                borderBottom:
                  topTab === tab
                    ? "2px solid #00c2ff"
                    : "none",
                     paddingBottom: "2px",   
              }}
            >
              {tab}
            </SoftTypography>
          ))}
        </SoftBox>

        {/* RIGHT MENU ICON */}
        <IconButton
          size="small"
          onClick={() => setMiniSidenav(dispatch, !miniSidenav)}
          sx={{ color: "#fff" }}
        >
          <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
        </IconButton>
      </SoftBox>
    </SoftBox>
  );
}

export default Header;
